import { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { SL_ROUTES } from "app/pages/sales-intelligence/constants/sl_routes";
import { SuppressionListCard } from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-cards/SuppressionListCard/SuppressionListCard";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import {
    deleteSuppressionListAsync,
    fetchSuppressionListsThunk,
} from "app/pages/sales-intelligence/sub-modules/management/store/effects/suppressionListApi";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { DeleteModal } from "../../components/ManagementSections/components/Modals/DeleteModal";
import ReplaceModal from "../../components/ManagementSections/components/Modals/ReplaceModal";

export const SuppressionListSectionContainer = () => {
    const dispatch = useDispatch();
    const hasSuppressionListAccess = salesSettingsHelper.hasSlAccess();

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isReplaceModalOpen, setIsReplaceModalOpen] = useState(false);

    useEffect(() => {
        dispatch(fetchSuppressionListsThunk());
    }, []);

    const handleCreateList = () => {
        allTrackers.dispatchTrackEvent("suppression", "create list", "account suppression");
        proNavigator.go(SL_ROUTES.upload);
    };

    const handleReplaceListModal = () => {
        allTrackers.dispatchTrackEvent("suppression", "approve replace", "account suppression");
        proNavigator.go(SL_ROUTES.upload);
    };

    const handleDeleteList = () => {
        allTrackers.dispatchTrackEvent("suppression", "delete list", "account suppression/delete");
        setIsDeleteModalOpen(false);
        dispatch(deleteSuppressionListAsync());
    };

    const handleReplaceList = () => {
        allTrackers.dispatchTrackEvent("suppression", "replace list", "account suppression/replace");
        setIsReplaceModalOpen(true);
    };

    return (
        <>
            <SuppressionListCard
                onCreate={handleCreateList}
                onReplace={handleReplaceList}
                onDelete={() => setIsDeleteModalOpen(true)}
                hasSuppressionListAccess={hasSuppressionListAccess}
            />
            <ReplaceModal
                isOpen={isReplaceModalOpen}
                onConfirm={handleReplaceListModal}
                onClose={() => setIsReplaceModalOpen(false)}
            />
            <DeleteModal
                isOpen={isDeleteModalOpen}
                onConfirm={handleDeleteList}
                onClose={() => setIsDeleteModalOpen(false)}
            />
        </>
    );
};
